import React from "react";
import { CardContent, CircularProgress, FormControl, Grid, MenuItem, Select } from "@material-ui/core";
import { useSelector } from "react-redux";
import { useState } from "react";
import { country as countrys } from "./components/Terms";
import { FormattedMessage } from "react-intl";
import { CardPageItem } from "../custom/Page";
import HeaderPageItem from "../custom/HeaderPageItem";
import useContractsList from "../hooks/useContractsList";
import PageContainer from "../custom/Page";
import { withRouter } from "react-router-dom";

const ContractsReport = ({ location }) => {
  const currentUser = useSelector((state) => state.user.user.me);
  const [taxResidence, setTaxResidence] = useState(currentUser);
  const searchParam = location?.search;
  const { loading, contracts } = useContractsList();

  console.log("a", searchParam);
  if (loading) return <CircularProgress style={{ marginTop: "25%" }} />;
  return (
    <PageContainer>
      <HeaderPageItem title="app.contracts" showBackButton destination="/reports" />
      <CardPageItem raised>
        <CardContent>
          <Grid container>
            <Grid item xs={6}>
              <FormControl variant="outlined" fullWidth size="small">
                <Select value={taxResidence} onChange={(e) => setTaxResidence(e.target.value)}>
                  {countrys.map((ctry) => (
                    <MenuItem key={ctry.value} value={ctry.value}>
                      <FormattedMessage id={ctry.input} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={3}></Grid>
          </Grid>
        </CardContent>
      </CardPageItem>
    </PageContainer>
  );
};

export default withRouter(ContractsReport);
